"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSelectorBasedOnLength = void 0;
exports.useParamSelector = useParamSelector;
exports.createParameterSelector = createParameterSelector;
const react_redux_1 = require("react-redux");
const reselect_1 = require("reselect");
// TODO support typings
function useParamSelector(selector, ...params) {
    return (0, react_redux_1.useSelector)((state) => selector(state, ...params));
}
// A helper function to create the parameter selectors
function createParameterSelector(selector) {
    return (_, params) => selector(params);
}
exports.createSelectorBasedOnLength = (0, reselect_1.createSelectorCreator)(reselect_1.lruMemoize, (a, b) => a.length === b.length);
//# sourceMappingURL=selectors.js.map